import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';
import s from '../styles/DetailContent.module.css';

const Knowledge40 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='藤田観光グループのゴルフ会員権とは？' fontWeight={700} />
                <p>
                    藤田観光グループは「ホテル椿山荘東京」などのホテル事業を中核とする企業グループで、ゴルフ場事業も展開しています。
                    <br />
                    確認できる運営コースは以下のとおりです。
                </p>
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/62'>カメリアヒルズカントリークラブ</a>（千葉県袖ケ浦市）
                </div>
                <p>
                    カメリアヒルズカントリークラブは、著名なゴルフコース設計家である安田幸吉氏の設計によるコースです。
                    <br />
                    日本女子プロゴルフツアー「アース・モンダミンカップ」の開催コースとしても知られています。
                </p>
                <p>
                    ※藤田観光グループのゴルフ場事業は他グループと比べて情報が限定的で、会員種別や優待特典の詳細については公式情報として確認できませんでした。
                    <br />
                    検討される際は、必ずクラブへ直接お問合せのうえ最新情報をご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='カメリアヒルズカントリークラブの魅力' fontWeight={700} />
                <Heading3 title='女子プロトーナメント開催コース' />
                <p>
                    トーナメント開催コースとして整備・管理されているため、コースコンディションの良さに定評があります。
                    <br />
                    本格的な設計のコースでプレーしたい方に選ばれています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    藤田観光グループのゴルフ会員権をご検討の際は、コースの詳細情報や売買状況について弊社にお気軽にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge40;
